/**
 * City Planner screen IDs used for stacked navigation.
 */
export const CITY_PLANNER_SCREENS = {
  SUBAREA_LIST: "subareaList",
  AREA_DRAW: "areaDraw",
  SCORING: "scoring",
} as const;

/**
 * Screen IDs that represent the subarea selection/drawing flow.
 * When the navigation stack contains any of these screens,
 * certain UI behaviors are suppressed (e.g., auto-opening properties panel).
 */
export const SUBAREA_FLOW_SCREENS: string[] = [CITY_PLANNER_SCREENS.SUBAREA_LIST, CITY_PLANNER_SCREENS.AREA_DRAW];
